import { DealType, FilterTypes, InventoryContentType, InventoryTypeV2, RemoteConfigProperties } from "../../../types";
import { lastValueFrom } from "rxjs";
const hasSuperTagDeals = (sdk, dealIds) => {
    return lastValueFrom(sdk.deals.find({
        where: [
            {
                field: "id",
                value: dealIds,
                type: FilterTypes.IN
            }
        ]
    })).then((deals) => !!deals.find((deal) => deal.deal?.type === DealType.SUPER_TAG));
};
const hasContentTargeting = (sdk, item) => {
    if (sdk.featureFlags.isFlagEnabled(RemoteConfigProperties.GENRE_LANGUAGE_TARGETING_LOGIC)) {
        return !!(item.genres?.length || item.languages?.length);
    }
    return !!item.contentType;
};
export const validators = (sdk) => ({
    inventoryIds: async (item, value) => {
        const inventoryIds = Array.isArray(value) ? value : [];
        if (item.inventoryType !== InventoryTypeV2.PRIVATE_O_AND_O &&
            item.inventoryType !== InventoryTypeV2.SELF_SOURCED &&
            item.inventoryType !== InventoryTypeV2.MADHIVE_PUBLIC) {
            return undefined;
        }
        if (value === undefined) {
            return undefined;
        }
        if (Array.isArray(value) && value.length === 0) {
            return "A deal must be selected.";
        }
        if (hasContentTargeting(sdk, item) && (await hasSuperTagDeals(sdk, inventoryIds))) {
            return "Content object cannot be applied with SuperTags.";
        }
        return undefined;
    },
    genres: (item, value) => {
        if (sdk.featureFlags.isFlagEnabled(RemoteConfigProperties.GENRE_LANGUAGE_TARGETING_LOGIC)) {
            return undefined;
        }
        if (item.contentType !== InventoryContentType.GENRE) {
            return undefined;
        }
        if (!(Array.isArray(value) && value?.[0])) {
            return "A genre must be selected.";
        }
        return undefined;
    },
    languages: (item, value) => {
        if (sdk.featureFlags.isFlagEnabled(RemoteConfigProperties.GENRE_LANGUAGE_TARGETING_LOGIC)) {
            return undefined;
        }
        if (item.contentType !== InventoryContentType.LANGUAGE) {
            return undefined;
        }
        if (!(Array.isArray(value) && value?.[0])) {
            return "A language must be selected.";
        }
        if (item.genres?.[0]) {
            return "Cannot select both genre and language.";
        }
        return undefined;
    },
    volumeCapPct: (item, value) => {
        if (!Number.isFinite(value)) {
            return "Volume cap percentage must be a number.";
        }
        if (value < 0 || value > 100) {
            return "Volume cap percentage must be between 0 and 100.";
        }
        return undefined;
    },
    priority: (item, value) => {
        if (!Number.isFinite(value)) {
            return "Priority must be a number.";
        }
        const has10PriorityTiers = sdk.featureFlags.isFlagEnabled(RemoteConfigProperties.HAS_10_PRIORITY_TIERS);
        const maxTier = has10PriorityTiers ? 10 : 5;
        if (value < 1 || value > maxTier) {
            return `Priority must be between 1 and ${maxTier}.`;
        }
        return undefined;
    },
    contentType: async (item, value) => {
        if (!value) {
            return undefined;
        }
        if (item.inventoryIds?.length && (await hasSuperTagDeals(sdk, item.inventoryIds))) {
            return "Content object cannot be applied with SuperTags.";
        }
        return undefined;
    },
    inventoryType: (item, value) => {
        const field = value?.trim();
        if (!field) {
            return "Inventory type selection is required.";
        }
        if (!Object.values(InventoryTypeV2).includes(field)) {
            return "A valid inventory type must be selected.";
        }
        return undefined;
    },
    publisherIds: (item, value) => {
        if (value === null || (Array.isArray(value) && value.length === 0)) {
            return "At least one publisher type must be selected.";
        }
        return undefined;
    },
    pubGroupId: (item, value) => {
        if (value === null || (typeof value === "string" && !value.trim().length)) {
            return "At least one publisher allow list must be selected.";
        }
        return undefined;
    },
    name: (item, value) => {
        if (!value?.trim()?.length) {
            return "Name is required.";
        }
        return undefined;
    }
});
//# sourceMappingURL=validators.js.map